<template>
  <div
    style="min-height: 100vh; transition: background-color 150ms ease-in-out;"
    :style="{
      background: darkMode ? null : '#f1f1f1',
    }"
  >
    <TopBar :header="header" />

    <v-main>
      <v-container
        class="pt-10 mb-5"
        style="max-width: 1124px;"
        fluid
      >
        <v-fade-transition mode="out-in">
          <router-view :key="`key_${$route.name}${$route.params.id ? $route.params.id : ''}`" />
        </v-fade-transition>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TopBar from '@/views/components/TopBar.vue';

export default {
  name: 'Settings',

  components: {
    TopBar,
  },

  data: () => ({ }),

  computed: {
    ...mapState({
      darkMode: (state) => state.displaySettings.darkMode,
      user: (state) => state.account.user,
    }),

    header() {
      const header = {
        title: {
          text: 'Settings',
          cta: 'settings',
        },
        menus: [
          { text: 'Home', icon: 'mdi-home-outline', to: { name: 'settings' } },
          { text: 'Personal Info', icon: 'mdi-certificate-outline', to: { name: 'profileInfo' } },
          { text: 'Security', icon: 'mdi-shield-account-outline', to: { name: 'security' } },
          // {
          //   text: 'Cobranding',
          //   icon: 'mdi-palette',
          //   to: { name: 'cobranding' },
          //   coach: true,
          //   disabled: !this.user.override_cobranding,
          // },
          {
            text: 'Subscription',
            icon: 'mdi-file-certificate-outline',
            // to: { name: 'subscription' },
            direct: process.env.VUE_APP_ENV === 'prod' ? 'https://gcgroup.chargebeeportal.com/portal/'
              : 'https://gcgroup-test.chargebeeportal.com/portal/',
          },
          // {
          //   text: 'Calendar',
          //   icon: 'mdi-calendar',
          //   to: { name: 'calendars' },
          //   disabled: false,
          //   coach: true,
          // },
        ],
      };

      header.menus = header.menus.filter((el) => {
        if (el.coach) return this.user.is_coach;
        return true;
      });

      return header;
    },
  },

  watch: {
    darkMode: {
      immediate: true,
      handler(newValue) {
        this.$vuetify.theme.dark = newValue;
      },
    },
  },
};
</script>
